import { render, staticRenderFns } from "./mrd.vue?vue&type=template&id=770a42e8&"
import script from "./mrd.vue?vue&type=script&lang=js&"
export * from "./mrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports